/**
 * 描述：左侧导航工具条 -app
 * 日期：2017-9-20
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('leftToolsModule', [])
    .directive('leftTools', ['$compile', '$timeout', function ($compile, $timeout) {
        return {
            restrict: 'A',
            replace: false,
            template: '',
            transclude: false,
            scope: false,
            link: function (scope, $elem, $attrs) {
                var $template, // 模板
                    myTimeout;// 延时器
                scope.platform = $attrs['platform']; // 所属平台
                init();

                /**
                 * [init description] 初始化
                 * @return {[type]} [description]
                 */
                function init() {
                    bindMouseEnter();
                    bindMouseLeave();
                    initDestroy();
                }

                /**
                 * [initDestroy description] 初始化监听销毁事件
                 * @return {[type]} [description]
                 */
                function initDestroy() {
                    scope.$on('$destroy', function () {
                        $('.quickOperat_wrap').remove();
                    });
                }

                /**
                 * [initTemplate description] 初始化模板
                 * @return {[type]} [description]
                 */
                function initTemplate() {
                    return $(['<div class="quickOperat_wrap">',
                        '<div class="arrow"></div>',
                        '<span class="quickBtn UpHeadlineBtn">',
                        // '<i class="iconfont icon-productmanagement_ap1" style="width: 68px;font-size:20px;" trs-Tooltip data-placement="auto top" data-container="body" title="设置为头条" ng-click="addUpHeadline(node)"></i>',
                        '<svg class="icon" trs-Tooltip data-placement="auto top" data-container="body" title="设置为头条" ng-click="addUpHeadline(node)" > ',
                        '<use xlink:href="#icon-productmanagement_ap1"></use>',
                        '</svg>',
                        '</span>',
                        '</div>'
                    ].join(''));
                }

                /**
                 * [bindMouseEnter description] 绑定鼠标移入事件
                 * @return {[type]} [description]
                 */
                function bindMouseEnter() {
                    $elem.bind('mouseenter', function () {
                        $template = initTemplate();
                        $template.css({ 'top': $elem.offset().top - 2, display: 'block', width: '68px' });

                        showCollected(function (flag) {
                            $template.bind('mouseenter', function () {
                                clearTimeout(myTimeout);
                            });
                            $template.bind('mouseleave', function () {
                                $template.remove();
                                $('div[role="tooltip"]').remove();
                            });
                            $template.find('use').click(function () {
                                $("div[role='tooltip']").remove();
                                $template.remove();
                            });
                            $template.find('use').bind('mouseenter', function () {
                                $template.find('use').remove();
                                $template.find('svg').html('<use xlink:href="#icon-productmanagement_ap"></use>');
                            });
                            $template.find('use').bind('mouseleave', function () {
                                $template.find('svg').html('<use xlink:href="#icon-productmanagement_ap1"></use>');
                            });
                            $template = $compile($template)(scope);
                            if (flag) {$('body').append($template);}
                        });
                    });
                }

                /**
                 * [showCollected description] 是否显示收藏按钮
                 * @param   {[type]}  success  [success description]
                 * @return  {[type]}           [return description]
                 */
                function showCollected(success) {
                    $timeout(function () {
                        var flag = true;
                        if (scope.$parent.status.UpHeadline) {
                            var UpHeadline = scope.$parent.status.UpHeadline;
                            if (scope.node.CHANNELID === UpHeadline.CHNLID) {
                                flag = false;
                            }
                        }
                        success(flag);
                    });
                }

                /**
                 * [bindMouseLeave description] 绑定鼠标离开事件
                 * @return {[type]} [description]
                 */
                function bindMouseLeave() {
                    $elem.bind('mouseleave', function () {
                        myTimeout = setTimeout(function () {
                            $template.remove();
                        });
                    });
                }
            }
        };
    }]);
